import * as SliderStoreActions from './actions';
import * as SliderStoreSelectors from './selectors';
import * as SliderStoreState from './state';

export { SliderStoreModule } from './slider-store.module';

export { SliderStoreActions, SliderStoreSelectors, SliderStoreState };
